import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-shortcut"
export default class extends Controller {
  static targets = ["input"]

  focusInput(event) {
    const isShortcut = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k"
    if (!isShortcut) return

    event.preventDefault()
    this.inputTarget.focus()
    this.inputTarget.select()
  }
}
